import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LogisticNetwork } from '@/types/data';

type NetworkContextType = {
  currentNetwork: LogisticNetwork | null;
  setCurrentNetwork: (network: LogisticNetwork | null) => void;
  isNetworkModified: boolean;
  setIsNetworkModified: (isModified: boolean) => void;
};

const NetworkContext = createContext<NetworkContextType | undefined>(undefined);

export const NetworkProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentNetwork, setCurrentNetwork] = useState<LogisticNetwork | null>(null);
  const [isNetworkModified, setIsNetworkModified] = useState<boolean>(false);

  // Reset the modified flag when changing networks
  const handleSetCurrentNetwork = (network: LogisticNetwork | null) => {
    setCurrentNetwork(network);
    setIsNetworkModified(false);
  };

  return (
    <NetworkContext.Provider
      value={{
        currentNetwork,
        setCurrentNetwork: handleSetCurrentNetwork,
        isNetworkModified,
        setIsNetworkModified,
      }}
    >
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetworkContext = () => {
  const context = useContext(NetworkContext);
  if (context === undefined) {
    throw new Error('useNetworkContext must be used within a NetworkProvider');
  }
  return context;
};
